import { defineMessages } from "react-intl";

export default defineMessages({
  goBack: {
    id: "backButton.goBack",
    defaultMessage: "Go back",
  },
});
